/*
 * � 2020 Microsoft. All rights reserved.
 */

define('SolitaireShared/CardLogic/CardValue',['lodash'], function(_) {
    return {
        "Values": {
            "Joker": 0,
            "Ace": 1,
            "Two": 2,
            "Three": 3,
            "Four": 4,
            "Five": 5,
            "Six": 6,
            "Seven": 7,
            "Eight": 8,
            "Nine": 9,
            "Ten": 10,
            "Jack": 11,
            "Queen": 12,
            "King": 13
        },
        "IntMap": {
            "0": "Joker",
            "1": "Ace",
            "2": "Two",
            "3": "Three",
            "4": "Four",
            '5': "Five",
            "6": "Six",
            "7": "Seven",
            "8": "Eight",
            "9": "Nine",
            "10": "Ten",
            "11": "Jack",
            "12": "Queen",
            "13": "King"
        },
        "getValue": function(key) {
            var parsedKey = key;

            if(_.isString(key) && key.length > 2) {
                // this is something like "ten" or "king" instead of Ten/King
                parsedKey = key[0].toUpperCase() + key.slice(1).toLowerCase();
            } else if(_.isString(key)){
                // this is a string representing an int
                parsedKey = this.IntMap[key];
            }

            return this.Values[parsedKey];
        }
    };
});

